import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Small = makeShortcode("Small");
const DateUpdated = makeShortcode("DateUpdated");
const Spotify = makeShortcode("Spotify");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2 {...{
      "id": "hi-im-scott",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#hi-im-scott",
        "aria-label": "hi im scott permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Hi I’m Scott`}</h2>
    <Small mdxType="Small">
  Last updated: <DateUpdated date={`2021-01-20`} small={`true`} mdxType="DateUpdated" />
    </Small>
    <p>{`I’m a web developer for Creative Products at `}<a parentName="p" {...{
        "href": "https://karmarama.com",
        "target": "_blank",
        "rel": "noopener"
      }}>{`Karmarama`}</a>{`, based in
Farringdon, London UK. Currently working from home.`}</p>
    <p>{`I’m a second career dev, that reskilled from a VBA analyst developer
role into web development.`}</p>
    <p>{`I have (as of `}<DateUpdated date={`2021-01-20`} mdxType="DateUpdated" />{`) a 1,486 day GitHub
streak, there are several OSS projects I like to contribute to the
majority of my commits are for my projects, feel free to take a look
👀`}</p>
    <p>{`I’m a massive fan of the `}<a parentName="p" {...{
        "href": "https://jamstack.org/",
        "target": "_blank",
        "rel": "noopener"
      }}>{`jamstack`}</a>{` and in particular the progressive
web app generator `}<a parentName="p" {...{
        "href": "https://www.gatsbyjs.org/",
        "target": "_blank",
        "rel": "noopener"
      }}>{`Gatsby`}</a>{`. Right now I’m enjoying integrating that
with as many things as possible, here are some examples:`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://scottspence.com",
          "target": "_blank",
          "rel": "noopener"
        }}>{`This site`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://cheatsheets.xyz",
          "target": "_blank",
          "rel": "noopener"
        }}>{`Cheat Sheets`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://mecv.xyz",
          "target": "_blank",
          "rel": "noopener"
        }}>{`My CV`}</a></li>
    </ul>
    <p>{`More details in the `}<a parentName="p" {...{
        "href": "#portfolio"
      }}>{`portfolio section`}</a>{`.`}</p>
    <h3 {...{
      "id": "sectors-i-have-worked-in",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#sectors-i-have-worked-in",
        "aria-label": "sectors i have worked in permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Sectors I have worked in:`}</h3>
    <p>{`Finance (Risk, Asset Management), Property, Oil & Gas, Lloyd’s
insurance market. As a web developer I’ve worked in government digital
transformation and now creative digital.`}</p>
    <h3 {...{
      "id": "my-personality",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#my-personality",
        "aria-label": "my personality permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`My personality`}</h3>
    <p>{`I find it hard to identify my traits, so instead I took the
`}<a parentName="p" {...{
        "href": "https://www.16personalities.com/",
        "target": "_blank",
        "rel": "noopener"
      }}>{`16Personalities`}</a>{` test, here are `}<a parentName="p" {...{
        "href": "https://www.16personalities.com/profiles/ba01a67248b68",
        "target": "_blank",
        "rel": "noopener"
      }}>{`my results`}</a>{`.`}</p>
    <h2 {...{
      "id": "my-interests",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#my-interests",
        "aria-label": "my interests permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`My interests`}</h2>
    <p>{`I try to get to the gym three times a week to weight lift, that took
up quite a bit of my time over the last 3 years or so. I have focused
on the compound lifts bench, press, squat and my favourite,
`}<a parentName="p" {...{
        "href": "https://www.youtube.com/watch?v=b8sadCd7Lhc",
        "target": "_blank",
        "rel": "noopener"
      }}>{`deadlift`}</a>{`!`}</p>
    <p>{`If there’s anything you want to ask, you can `}<a parentName="p" {...{
        "href": "https://github.com/spences10/ama",
        "target": "_blank",
        "rel": "noopener"
      }}>{`Ask Me Anything`}</a></p>
    <h3 {...{
      "id": "music-i-listen-to",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#music-i-listen-to",
        "aria-label": "music i listen to permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Music I listen to`}</h3>
    <p>{`I’m a massive Drum and Bass fan, I have a Spotify playlist I like to
listen to for coding with the title for which I stole from Phil
Hawksworth:`}</p>
    <Spotify spotifyLink="playlist/4etN3fawLp5rWiAFdJZQp5?si=bWljWzzsTq2kFj6hq5f-lQ" width="100%" mdxType="Spotify" />
    <p>{`Other playlists I’d recommend would be the UKF Drum and Bass Top 100:`}</p>
    <Spotify spotifyLink="playlist/0Zarq4BVkFkZOWkmqsfrjA?si=x3WLxJnVS12NVWWDt1LUXg" width="100%" mdxType="Spotify" />
    <h3 {...{
      "id": "now-playing---spotify-",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#now-playing---spotify-",
        "aria-label": "now playing   spotify  permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Now Playing - Spotify 🎧`}</h3>
    <p><a parentName="p" {...{
        "href": "https://open.spotify.com/user/spences10",
        "target": "_blank",
        "rel": "noopener"
      }}><img parentName="a" {...{
          "src": "https://spotify-now-playing.spences10.vercel.app/api/spotify-playing",
          "alt": "Scott, Spotify Playing",
          "width": 350
        }}></img></a></p>
    <h3 {...{
      "id": "podcasts-i-listen-to",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#podcasts-i-listen-to",
        "aria-label": "podcasts i listen to permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Podcasts I listen to`}</h3>
    <p>{`I listen to many podcasts, here are some that I get a lot of value
from that aren’t all code related:`}</p>
    <p>{`Darknet Diaries`}</p>
    <Spotify spotifyLink="show/4XPl3uEEL9hvqMkoZrzbx5" width="100%" height="180px" mdxType="Spotify" />
    <p>{`Indie Hackers`}</p>
    <Spotify spotifyLink="show/4ex8hmrHCPvPohKJb3wsuC" width="100%" height="180px" mdxType="Spotify" />
    <hr></hr>
    {
      /* Links */
    }

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      